"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const strings_1 = require("../../../../constants/strings");
const zustandStore_1 = require("../../../../zustandStore");
const slices_1 = require("../../../../zustandStore/slices");
const charts_1 = __importDefault(require("../components/charts"));
const dashboard_1 = require("../dashboard");
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return ((0, jsx_runtime_1.jsx)("div", { role: "tabpanel", hidden: value !== index, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}`, ...other, children: value === index && (0, jsx_runtime_1.jsx)(material_1.Box, { children: children }) }));
}
const SpendOverTime = () => {
    const theme = (0, material_1.useTheme)();
    const { timeSpan, setTimeSpan } = (0, zustandStore_1.useZustand)(state => ({
        timeSpan: state.dashboard.timeSpan,
        setTimeSpan: state.setTimeSpan,
    }));
    const handleChange = (_, newValue) => {
        setTimeSpan(newValue);
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
            ml: 1,
        }, children: [(0, jsx_runtime_1.jsx)(dashboard_1.StyledSubTitle, { "data-testid": "spendOverTime", children: strings_1.dashboardStrings.SPEND_OVER_TIME }), (0, jsx_runtime_1.jsxs)(material_1.Card, { sx: { width: '100%', padding: 0 }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: { borderBottom: 1, borderColor: 'divider' }, children: (0, jsx_runtime_1.jsx)(dashboard_1.StyledGraphTabs, { value: timeSpan, onChange: handleChange, slotProps: {
                                indicator: {
                                    style: {
                                        backgroundColor: `${theme.palette.tsGoColor.black}`,
                                    },
                                },
                            }, children: slices_1.timeSpanOptions.map((item, index) => ((0, jsx_runtime_1.jsx)(material_1.Tab, { "data-testid": item.value, label: item.label, value: item.value }, index))) }) }), (0, jsx_runtime_1.jsx)(CustomTabPanel, { value: timeSpan, index: timeSpan, children: (0, jsx_runtime_1.jsx)(charts_1.default, {}) })] })] }));
};
exports.default = SpendOverTime;
